import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { Message } from '../../types';

interface ChatStore {
  messages: Record<string, Message[]>;
  addMessage: (summaryId: string, message: Message) => void;
  clearChat: (summaryId: string) => void;
}

export const useChatStore = create<ChatStore>()(
  persist(
    (set) => ({
      messages: {},
      addMessage: (summaryId, message) =>
        set((state) => {
          const existingMessages = state.messages[summaryId] || [];
          const messageExists = existingMessages.some((m) => m.id === message.id);

          if (messageExists) {
            return state;
          }

          return {
            messages: {
              ...state.messages,
              [summaryId]: [...existingMessages, message],
            },
          };
        }),
      clearChat: (summaryId) =>
        set((state) => ({
          messages: {
            ...state.messages,
            [summaryId]: [],
          },
        })),
    }),
    {
      name: 'tubeonai-chat-storage',
    }
  )
);
